(() => {
  const section = document.querySelector('[data-product-section]');
  const options = section?.querySelector('[data-product-options]');
  if (!options) return;
  const material = options.querySelector('[data-option-kind="material"]');
  const native = options.hasAttribute('data-film-native-options');
  const groups = [...options.querySelectorAll('[data-option-group]')].filter(group => group !== material && (native || !group.hidden));
  if (!groups.length) return;
  const media = window.matchMedia('(max-width: 749px)');
  const tabs = document.createElement('div');
  tabs.className = 'product-option-tabs';
  tabs.setAttribute('role', 'tablist');
  tabs.setAttribute('aria-label', 'Choose your print options');
  const indicator = document.createElement('span');
  indicator.className = 'product-option-tab-indicator';
  indicator.setAttribute('aria-hidden', 'true');
  tabs.append(indicator);
  let active = 0;
  const visible = () => groups.map((group,index) => group.hidden ? -1 : index).filter(index => index >= 0);
  const buttons = groups.map((group,index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-option-tab';
    button.id = group.id + '-tab';
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', group.id);
    const label = document.createElement('span');
    label.className = 'product-option-tab-label';
    label.textContent = group.dataset.optionName;
    const value = document.createElement('span');
    value.className = 'product-option-tab-value';
    button.append(label,value);
    button.addEventListener('click', () => activate(index));
    button.addEventListener('keydown', event => {
      const choices = visible();
      const at = choices.indexOf(index);
      let next;
      if (event.key === 'ArrowRight') next = choices[(at + 1) % choices.length];
      else if (event.key === 'ArrowLeft') next = choices[(at - 1 + choices.length) % choices.length];
      else if (event.key === 'Home') next = choices[0];
      else if (event.key === 'End') next = choices.at(-1);
      else return;
      event.preventDefault();
      activate(next);
      buttons[next].focus();
    });
    tabs.append(button);
    return button;
  });
  function activate(index) {
    const choices = visible();
    if (!choices.length) return;
    if (!choices.includes(index)) index = choices[0];
    options.style.setProperty('--option-enter-from',index < active ? '-8px' : '8px');
    active = index;
    indicator.style.width = 'calc((100% - ' + (8 + 6 * (choices.length - 1)) + 'px) / ' + choices.length + ')';
    const position = choices.indexOf(active);
    indicator.style.transform = 'translateX(calc(' + position * 100 + '% + ' + position * 6 + 'px))';
    groups.forEach((group,i) => {
      const selected = i === active;
      buttons[i].hidden = group.hidden;
      buttons[i].setAttribute('aria-selected',String(selected));
      buttons[i].tabIndex = selected ? 0 : -1;
      group.classList.toggle('is-inactive-option',media.matches && !selected);
      if (media.matches) {
        group.setAttribute('role','tabpanel');
        group.setAttribute('aria-labelledby',buttons[i].id);
      } else {
        group.removeAttribute('role');
        group.removeAttribute('aria-labelledby');
      }
    });
  }
  function sync() {
    groups.forEach((group,index) => {
      buttons[index].querySelector('.product-option-tab-value').textContent = (group.querySelector('input:checked')?.value || '').split(' (')[0];
    });
    activate(active);
  }
  if (material) material.after(tabs); else options.prepend(tabs);
  options.classList.add('product-options--tabbed');
  section.querySelector('[data-product-form]').addEventListener('change', () => queueMicrotask(sync));
  media.addEventListener('change',sync);
  sync();
})();
